<div
  class="preferences-picker"
  [class.compact]="compact"
>
  <div class="field">
    <label>{{ 'language' | translate }}</label>
    <div>
      <mat-form-field
        appearance="outline"
        subscriptSizing="dynamic"
      >
        <mat-select
          [ngModel]="selectedLanguageCode"
          (ngModelChange)="onChangeLanguage($event)"
        >
          <mat-option [value]="USE_SYSTEM_DEFAULT">
            {{ 'useSystemDefault' | translate }}
          </mat-option>
          @for (lang of languages; track lang.code) {
            <mat-option [value]="lang.code">{{ lang.title }}</mat-option>
          }
        </mat-select>
      </mat-form-field>
      @if (!compact && systemLanguageLabel) {
        <div class="hint">{{ 'systemDefault' | translate }}: {{ systemLanguageLabel }}</div>
      }
    </div>
  </div>

  <div class="field">
    <label>{{ 'units' | translate }}</label>
    <div>
      <mat-form-field
        appearance="outline"
        subscriptSizing="dynamic"
      >
        <mat-select
          [ngModel]="selectedInchesUnit"
          (ngModelChange)="onChangeInchesUnit($event)"
        >
          <mat-option [value]="USE_SYSTEM_DEFAULT">
            {{ 'useSystemDefault' | translate }}
          </mat-option>
          @for (unit of unitOptions; track unit.key) {
            <mat-option [value]="unit.key">{{ unit.title }}</mat-option>
          }
        </mat-select>
      </mat-form-field>
      @if (!compact && systemInchesUnitLabel) {
        <div class="hint">{{ 'systemDefault' | translate }}: {{ systemInchesUnitLabel }}</div>
      }
    </div>
  </div>
</div>
